<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CONVERSATION_STATUS } from 'shared/constants/messages';

import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
  showEmpty: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

// BonBoZ: tooltip truoc day in thang gia tri tho tu API — re chuot vao icon
// thi no noi "open", "resolved". Do la mot trong nhung ly do khong ai hieu
// trang thai nghia la gi.
const nhanTrangThai = computed(() =>
  props.status
    ? t(`CHAT_LIST.CONVERSATION_STATUS.${props.status.toUpperCase()}`)
    : ''
);

const icons = {
  [CONVERSATION_STATUS.OPEN]: 'i-woot-status-open',
  [CONVERSATION_STATUS.RESOLVED]: 'i-woot-status-resolved',
  [CONVERSATION_STATUS.PENDING]: 'i-woot-status-pending',
  [CONVERSATION_STATUS.SNOOZED]: 'i-woot-status-snoozed',
};

// BonBoZ: bốn trạng thái trước đây không có lớp màu nào cả — icon thừa hưởng
// màu xám của khối cha, nên "đang mở" và "đã xong" trông y hệt nhau.
//
// Theo đúng quy ước màu đã dùng ở panel CRM và nhãn SLA của chỗ này:
//   xanh dương = đang mở (việc đang chạy)
//   xanh lục   = đã xong
//   hổ phách   = đang chờ / tạm hoãn (chờ ai đó, chưa phải lỗi)
const mauTrangThai = {
  [CONVERSATION_STATUS.OPEN]: 'text-n-brand',
  [CONVERSATION_STATUS.RESOLVED]: 'text-n-teal-10',
  [CONVERSATION_STATUS.PENDING]: 'text-n-amber-10',
  [CONVERSATION_STATUS.SNOOZED]: 'text-n-amber-10',
};

const lopMau = computed(() => mauTrangThai[props.status] || 'text-n-slate-9');

const iconName = computed(() => {
  if (props.status && icons[props.status]) {
    return icons[props.status];
  }
  return props.showEmpty ? 'i-woot-status-empty' : '';
});
</script>

<template>
  <Icon
    v-tooltip.top="{
      content: nhanTrangThai,
      delay: { show: 500, hide: 0 },
    }"
    :icon="iconName"
    class="size-4 flex-shrink-0"
    :class="lopMau"
  />
</template>
